export default __webpack_public_path__ + "static/Mechanic-6002a82cf76863e81bd3ca53b611839b.png";